import { render } from "./ContactStepNewsletters.vue?vue&type=template&id=36b1fc7a"
import script from "./ContactStepNewsletters.vue?vue&type=script&lang=js"
export * from "./ContactStepNewsletters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__